// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5n2Gq","questions":"styles_questions__2GAi0","footer":"styles_footer__3vXGE"};